import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { Stockitem } from '../../../../interfaces/stockitem';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';
import { BundleService } from '../../../../services/bundles';
import { Router } from '@angular/router';


@Component({
  selector: 'app-deals',
  templateUrl: './deals.component.html',
  styleUrl: './deals.component.scss'
})
export class DealsComponent implements OnInit {

  contentReady = true;
  allData: Stockitem[] = [];
  noData = false;

  totalItems = 0;
  stockTotal: any;
  page = 1;

  isAr = false;
  isMobile = false;
  itemCount = 9;
  isFullPage = false;
  private isBrowser: boolean;

  constructor(
    private deviceService: DeviceDetectorService,
    private _bundles: BundleService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    // ⛔ السيرفر يقف هنا
    if (!this.isBrowser) {
      return;
    }
    const currentUrl = this.router.url;

    if (currentUrl.includes('deals')) {
      this.isFullPage = true;
    }
    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.itemCount = this.isMobile ? 8 : 9;
    this.isAr = localStorage.getItem('language') === 'ar';

    this.getHotDeals();
  }

  // ================= DATA =================
  getHotDeals(): void {
    this.contentReady = true;
    this.page = 1;

    this._bundles
      .getAll(this.page, 10)
      .subscribe({
        next: (res: any) => {
          this.allData = res.data;
          this.stockTotal = res.total;
          this.totalItems = res.last_page;
          this.noData = this.stockTotal === 0;
          this.contentReady = false;
        },
        error: (err) => {
          console.error('Error fetching hot deals:', err);
          this.contentReady = false;
          this.noData = true;
        }
      });
  }

  // ================= INFINITE SCROLL =================
  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    if (!this.isBrowser || this.contentReady) return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached =
      scrollPosition + windowHeight >= pageHeight - 10;

    if (this.page === 1) {
      this.page = 2;
    }

    if (bottomReached && this.page <= this.totalItems) {
      this.loadMore();
    }
  }

  private loadMore(): void {
    this.contentReady = true;

    this._bundles
      .getAll(this.page, 10)
      .subscribe({
        next: (res: any) => {
          this.allData = [...this.allData, ...res.data];
          this.page++;
          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        },
      });
  }
}
